module.exports = __webpack_public_path__ + "static/media/medico.157a549c.svg";